import React from 'react';

function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3">
      <div
        className="w-9 h-9 rounded-full animate-spin"
        style={{ border: '2px solid rgba(0,255,240,0.1)', borderTopColor: 'var(--aqua)' }}
      />
      <p className="text-xs font-medium tracking-widest uppercase" style={{ color: 'var(--text-muted)' }}>
        {message}
      </p>
    </div>
  );
}

export default LoadingSpinner;
